import React from "react";

import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";

export default function Password({
  showEdit,
  passType,
  newPassType,
  confirmedPassType,
  showHidePassword,
  handleSaveCancelClick,
  handleSaveEditClick,
  handleEditClick,
  loading,
}) {
  if (showEdit) {
    return (
      <>
        <div className="myAccountProfileInputContainer">
          <div className="myAccountFormTitle">
            Password
          </div>
          <div className="my-profile-change-password-container">
            <div className="my-profile-old-password-row">
              <div className="myAccountFormTitle">
                Enter Old Password
              </div>
              <input
                id="myaccountpassword"
                type={passType}
                className="myaccountEditInput myaccountEditInputPassWidth"
                placeholder="Old Password"
                required
              />
              <span
                className="my-profile-password-toggle-icon"
                onClick={() => showHidePassword("passType", passType)}
              >
                {passType === "text" ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              </span>
            </div>

            <div className="my-profile-new-password-row">
              <div className="MyProfile__NewPassword">
                <div className="myAccountFormTitle"> New Password </div>
                <input
                  id="myaccountnewpassword"
                  type={newPassType}
                  className="myaccountEditInput myaccountEditInputPassWidth"
                  placeholder="New Password"
                  required
                />
                <span
                  className="my-profile-password-toggle-icon"
                  onClick={() => showHidePassword("newPassType", newPassType)}
                >
                  {newPassType === "text" ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                </span>
              </div>
              <div className="MyProfile__NewPassword">
                <div className="myAccountFormTitle">Confirm New Password</div>
                <input
                  id="myaccountconfirmedPassword"
                  type={confirmedPassType}
                  className="myaccountEditInput myaccountEditInputPassWidth"
                  placeholder="Confirm New Password"
                  required
                />
                <span
                  className="my-profile-password-toggle-icon"
                  onClick={() => showHidePassword("confirmedPassType", confirmedPassType)}
                >
                  {confirmedPassType === "text" ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                </span>
              </div>
            </div>
            <div id="user-error" className="MyProfile__PasswordReqsDiv">
              <span>Must contain: at least 1 number, 1 uppercase, 1 lowercase letter, at least 6 characters, no spaces.</span>
            </div>
          </div>
        </div>
        <div className={loading ? "my-profile-cancel-submit-buttons my-profile-loading" : "my-profile-cancel-submit-buttons"}>
          <Button
            htmlType="button"
            type="default"
            onClick={() => handleSaveCancelClick()}
          >
            Cancel
          </Button>
          <Button
            htmlType="button"
            type="primary"
            onClick={() => handleSaveEditClick()}
          >
            Submit
          </Button>
        </div>
      </>
    );
  }

  return (
    <div className="myAccountProfileInputContainer">
      <div className="myAccountFormTitle">
        Password
      </div>
      <input
        type="text"
        placeholder="***************"
        className="myaccountDefaultInput"
        disabled
      />
      <div
        className="myAccountChangePsw"
        onClick={() => handleEditClick("password")}
      >
        Change password
      </div>
    </div>
  );
}
